/* eslint-disable react/display-name */
import * as React from 'react';

const AppIos = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M39.1 18.1c-3.8-.3-7 2.1-8.8 2.1-1.8 0-4.6-2.1-7.6-2-3.9.1-7.5 2.3-9.5 5.8-4.1 7-1 17.5 2.9 23.2 1.9 2.8 4.2 5.9 7.3 5.8 2.9-.1 4-1.9 7.5-1.9s4.5 1.9 7.6 1.8c3.1-.1 5.1-2.8 7-5.7 2.2-3.2 3.1-6.4 3.2-6.5-.1 0-6.1-2.3-6.2-9.3-.1-5.8 4.8-8.6 5-8.8-2.7-3.9-6.9-4.4-8.4-4.5M36.8 14.3c1.6-1.9 2.7-4.7 2.4-7.3-2.3.1-5.1 1.5-6.8 3.5-1.5 1.7-2.8 4.5-2.4 7.1 2.5.2 5.2-1.3 6.8-3.3" />
  </svg>
);

export default AppIos;
